import { LastPsychologist } from "utils/interfaces"

export function checkTimeRequestIfNoSlots(
    hash_id: string,
    psychologist: LastPsychologist[] | undefined
): LastPsychologist | undefined {
    return psychologist?.find(
        (item) => item.hash_id === hash_id && item.allow_time_request_if_no_slots
    )
}
